<template lang="pug">
  .pdp-xsell-modal(body-scroll-lock-ignore)
    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper
          .title-wrap.xs-12.text-center
            transition(name="fade" mode="out-in")
              p.bold.xs-f-large.lg-f-xlarge.max-at-tweak {{ modalTitle }}

          .routine-nav.xs-12.text-center(v-if="showMenu")
            button.btn-reset.xs-f-small.lg-f-xmedium.max-at-tweak(type="button" :class="{ selected: selectedComponent == 'BundleAndSave' }" @click="setComponent('BundleAndSave')")
              span.non-focusable(tabindex="-1") Bundle + Save
            button.btn-reset.xs-f-small.lg-f-xmedium.max-at-tweak(type="button" :class="{ selected: selectedComponent == 'XsellProducts' }" @click="setComponent('XsellProducts')")
              span.non-focusable(tabindex="-1") Products

          transition(name="fade" mode="out-in")
            keep-alive
              component(:is="selectedComponent" @show-tab="showXsellTab").xs-12

</template>

<script>
  import { mapState, mapGetters } from "vuex";
  export default {
    name: "PdpXsellModal",

    components: {
      'BundleAndSave': () => import('./BundleAndSave'),
      'XsellProducts': () => import('./XsellProducts')
    },

    data() {
      return {
        selectedComponent: 'BundleAndSave'
      }
    },

    mounted() {
      this.trackEvent('Complete the Routine Modal Viewed', {
        product_added_id: this.product.id,
        product_added_name: this.product.name
      });

      this.initComponent();
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('xsell', ['proProduct']),
      ...mapState('customer', ['cdata']),
      ...mapGetters('cart', [
        'productIdInCart',
        'suggestedAddons'
      ]),

      modalTitle() {
        let title = 'For the ultimate salon finish';

        if (this.selectedComponent == 'XsellProducts') {
          title = 'Recommended for you';
        }

        return title;
      },

      hasBoughtToolKit() {
        return !!(this.cdata && this.cdata.purchaseList && this.cdata.purchaseList.find(purchase => purchase.productId == 145));
      },

      showMenu() {
        return this.proProduct.id && !this.hasBoughtToolKit && this.suggestedAddons.length > 0;
      }
    },

    methods: {
      setComponent(component) {
        this.selectedComponent = component;
      },

      showXsellTab(data) {
        this.setComponent(data);
      },

      initComponent() {
        if (this.proProduct.id && !this.productIdInCart(this.proProduct.id) && !this.hasBoughtToolKit) {
          this.setComponent('BundleAndSave');
        } else if (this.suggestedAddons.length > 0) {
          this.setComponent('XsellProducts');
        } else {
          window.location = '/cart';
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .pdp-xsell-modal
    .title-wrap
      padding 2em 5%

    .routine-nav
      padding-bottom 1.5em

      button
        color color-slate
        border-bottom 1px solid color-fog-light
        width 13em

        span
          padding 0.5em

        &.selected
          color color-black
          border-bottom 4px solid color-mr-blue
          font-family font-family-primary-bold

    @media mq-mobile
      .title-wrap
        padding 1em 5%

      .routine-nav
        button
          width 50%

    @media mq-tablet
      .title-wrap
        padding 1em 10%

      .routine-nav
        padding-left 10%
        padding-right 10%

        button
          width 50%

</style>
